import { Theme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";
import placeholder from "assets/images/pngs/insights-charts-placeholder.png";

export default makeStyles((theme: Theme) =>
    createStyles({
        projection: {
            backgroundColor: theme.palette.common.white,
        },
        projectionPlaceholder: {
            backgroundImage: `url(${placeholder})`,
            display: "flex",
            alignItems: "center",
            position: "relative",
            width: "100%",
            height: "calc(100vh - 103px)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            border: "1px solid #EAEAEA",
            borderRadius: "11px",
            "& > *": {
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
            },
        },
    })
);
